// Shared reactive state for the global "Access Denied" banner.
// Any 403 response with a `category_code` field gets caught by the axios
// interceptor in api/index.js and pushed here; App.vue renders the banner
// based on this state.

import { reactive } from "vue";

export const accessDenied = reactive({
    visible:      false,
    category:     "",   // e.g. "demographics"
    required:     "",   // "view" | "edit"
    granted:      "",   // "none" | "view" | ...
    message:      "",   // human-readable server message
    triggeredAt:  null,
});

export function showAccessDenied(payload) {
    accessDenied.category    = payload.category_code || "";
    accessDenied.required    = payload.required      || "";
    accessDenied.granted     = payload.granted       || "";
    accessDenied.message     = payload.message       || "";
    accessDenied.triggeredAt = new Date();
    accessDenied.visible     = true;
}

export function dismissAccessDenied() {
    accessDenied.visible = false;
}
